<p *ngFor="let id of ids">
  <a [routerLink]="url(id)">{{(boardEntities$ | async)[id]?.name}}</a>
</p>
